import { render } from "./InternationalPhoneInput.vue?vue&type=template&id=56d0e390&scoped=true"
import script from "./InternationalPhoneInput.vue?vue&type=script&lang=js"
export * from "./InternationalPhoneInput.vue?vue&type=script&lang=js"

import "./InternationalPhoneInput.vue?vue&type=style&index=0&id=56d0e390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d0e390"]])

export default __exports__